import type { SpinResponse } from "@slot/client-engine";
import { MergeRoundBuilder } from "../../MergeRoundBuilder";
import { OFFLINE_ROUND } from "../offlineRound";

/**
 * A huge win up the high ladder in the top-right corner, fed from above the grid: a 2×2 H2 makes two H3 and the two H3
 * dropping into the top row complete the next square (×8 on its badges); its two H4 and the two H4 dropping in meet the
 * H4 below them — a 5-cell H4 cluster, ×12, which makes two FS and leaves one H4. 1.00 + 12.00 + 31.20 = 44.20, the
 * huge tier; two FS stay short of the trigger.
 */
export function bigWin(): SpinResponse {
  return new MergeRoundBuilder({ roundId: "merge-big-win", ...OFFLINE_ROUND })
    .baseSpin({
      board: [
        ["L1", "L3", "L2", "L1", "H2", "H2"],
        ["L2", "L4", "L1", "L3", "H2", "H2"],
        ["L3", "L1", "L4", "L2", "L1", "H4"],
        ["L1", "L2", "L3", "H1", "L3", "L1"],
        ["H1", "L3", "L1", "L4", "L2", "L3"],
        ["L2", "L1", "H3", "L2", "L1", "L4"],
      ],
      refill: [[], [], [], [], ["H3", "H4", "L4"], ["H3", "H4", "L2"]],
    })
    .build();
}
